<div class="banner">
  <quota-banner [hideTrialBanner]="true" [hideExpiredBanner]="true"></quota-banner>
</div>
<div class="container-fluid screenshots-page" *ngIf="!loading">
  <!-- Same horizontal rhythm as Employees / header: .container-fluid padding 16px 36px; no Materialize .row gutter -->
  <div class="screenshots-page-header">
    <h1 class="screenshots-page-title">Screenshots</h1>
  </div>
  <mat-card class="fluid-ss">
    <!-- Enhanced Filter Bar -->
    <div class="filter-bar">
      <div class="filter-header">
        <div class="filter-title-group">
          <mat-icon class="filter-icon">filter_list</mat-icon>
          <span class="filter-title">Filters</span>
        </div>
        <div class="filter-header-right">
          <div class="filter-count" *ngIf="total_ss > 0">
            <span class="count-badge">{{ total_ss }} screenshot{{ total_ss !== 1 ? 's' : '' }}</span>
          </div>
        </div>
      </div>

      <div class="filter-controls screenshots-filter-controls">
        <!-- Employee Filter -->
        <div class="filter-item">
          <label class="filter-label">
            <mat-icon class="label-icon">people</mat-icon>
            <span>Employee</span>
          </label>
          <app-employee-search [userList]="userList" [placeholder]="'All Employees'" class="w-full h-full"
            [selectedEmployeeId]="employeeMultiCtrl.value" (employeeSelected)="onEmployeeSelected($event)">
          </app-employee-search>
        </div>

        <!-- Date Range Filter -->
        <div class="filter-item filter-item--date-range">
          <label class="filter-label">
            <mat-icon class="label-icon">date_range</mat-icon>
            <span>Date Range</span>
          </label>
          <mat-form-field appearance="fill" floatLabel="never"
            class="date-range-picker-form-field screenshot-range-field" subscriptSizing="dynamic">
            <mat-date-range-input [formGroup]="screenshotDateRange" [rangePicker]="screenshotRangeDp"
              [min]="screenshotMatMinDate" [max]="screenshotMatMaxDate">
              <input matStartDate formControlName="start" placeholder="Start date" readonly>
              <input matEndDate formControlName="end" placeholder="End date" readonly>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="screenshotRangeDp"></mat-datepicker-toggle>
            <mat-date-range-picker #screenshotRangeDp (closed)="onScreenshotMatFilterChange()"></mat-date-range-picker>
          </mat-form-field>
        </div>

        <!-- Start Time Filter -->
        <div class="filter-item filter-item--time">
          <label class="filter-label" id="ss-filter-start-cap">
            <mat-icon class="label-icon" fontSet="material-symbols-outlined">schedule</mat-icon>
            <span>Start time</span>
          </label>
          <mat-form-field appearance="fill" floatLabel="never"
            class="date-range-picker-form-field screenshot-time-field" subscriptSizing="dynamic">
            <input matInput type="time" step="1" aria-labelledby="ss-filter-start-cap" [(ngModel)]="screenshotStartTimeStr"
              (ngModelChange)="scheduleScreenshotTimeFilterApply()">
          </mat-form-field>
        </div>

        <!-- End Time Filter -->
        <div class="filter-item filter-item--time">
          <label class="filter-label" id="ss-filter-end-cap">
            <mat-icon class="label-icon" fontSet="material-symbols-outlined">schedule</mat-icon>
            <span>End time</span>
          </label>
          <mat-form-field appearance="fill" floatLabel="never"
            class="date-range-picker-form-field screenshot-time-field" subscriptSizing="dynamic">
            <input matInput type="time" step="1" aria-labelledby="ss-filter-end-cap" [(ngModel)]="screenshotEndTimeStr"
              (ngModelChange)="scheduleScreenshotTimeFilterApply()">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="screenshot-time-hint" *ngIf="regionHint" role="note">
      <mat-icon class="hint-icon" fontSet="material-symbols-outlined">public</mat-icon>
      <span class="hint-text">{{ regionHint }}</span>
    </div>

    <div *ngIf="isloading" class="loading-section">
      <div class="row">
        <div class="col s12 m6 l6 screenshot-card" *ngFor="let loader of skeletonLoaders">
          <ngx-skeleton-loader class="skeleton-item" [theme]="skeletonTheme">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>

    <div class="row screenshot-card-main-row db-style-1">
      <div class="col s12 m6 l6 screenshot-card" [ngStyle]="{
          display: PhotoList.length ? 'block' : 'none',
          visibility: PhotoList.length ? 'visible' : 'hidden'
        }" *ngFor="let image of PhotoList">
        <div>

          <app-ss-card [image]="image" [userList]="userList" [isEmployeeProfile]="false" [isAdmin]="isAdmin"
            (imageOpenerEmitter)="onScreenshotCardClick($event)" (deleteScreenShotEmitter)="removeScreenShot($event)"
            (downloadScreenShotEmitter)="downloadScreenShot($event)">
          </app-ss-card>
        </div>
      </div>

      <div *ngIf="total_ss == 0 && !loading && !showExamplePreview" class="empty_list z-depth-2 remove-border" [ngStyle]="{
          display: !PhotoList.length && !isloading ? 'block' : 'none',
          visibility: !PhotoList.length && !isloading ? 'visible' : 'hidden'
        }">
        <app-activation-data-state
          kind="thin"
          title="No screenshots for this filter yet"
          body="If SuperSee is connected, captures may still be processing. Example workday shows what a full day looks like — not your company data.">
        </app-activation-data-state>
      </div>
      <app-example-preview-card
        *ngIf="showExamplePreview && total_ss == 0 && !loading && !PhotoList.length && !isloading"
        variant="apps"
        [ownWorkdayReady]="ownWorkdayReady">
      </app-example-preview-card>
      <app-optional-setup-help-links
        *ngIf="total_ss == 0 && !loading && !PhotoList.length && !isloading && !showExamplePreview"></app-optional-setup-help-links>
    </div>

    <div class="pagination-wrapper" *ngIf="total_ss > 0 && !isloading">
      <div class="pagination-container">
        <div class="pagination-right">
          <mat-paginator [length]="total_ss" [pageSize]="pageSize || 25" [pageIndex]="currentPage - 1"
            [pageNumber]="currentPage" [pageSizeOptions]="[25, 50, 100]" aria-label="Select page"
            (page)="onPageChange($event)" (pageNumber)="currentPage = $event" #EmpPaginator>
          </mat-paginator>
        </div>

        <div class="pagination-left">
          <mat-label
            style="font-size: 12px !important; font-weight: 500 !important; color: #4b5563 !important; margin:0px 4px !important;">Current
            Page: </mat-label>

          <mat-form-field class="page-selector-field" appearance="outline">
            <mat-select [(value)]="currentPage" (selectionChange)="goToPage($event.value)"
              panelClass="page-dropdown-panel">
              <mat-select-trigger>
                <span class="page-text">{{ currentPage }} of {{ total_pages }}</span>
              </mat-select-trigger>

              <!-- Search Input -->
              <div class="page-search-container">
                <mat-form-field class="page-search-field" appearance="outline" style="width: 100%;">
                  <input matInput placeholder="Search page number..." [(ngModel)]="pageSearchTerm"
                    (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                  <!-- <button mat-icon-button matSuffix 
                              *ngIf="pageSearchTerm"
                              (click)="pageSearchTerm = ''; $event.stopPropagation()">
                        <mat-icon class="clear-icon">close</mat-icon>
                      </button> -->
                </mat-form-field>
              </div>

              <!-- Page Options -->
              <mat-option *ngFor="let pageNum of getFilteredPages()" [value]="pageNum">
                <div class="page-item-content">
                  <div class="page-item-left">
                    <span class="page-number-badge" [class.active-badge]="currentPage === pageNum">
                      {{ pageNum }}
                    </span>
                    <!-- <span class="page-label">Page {{ pageNum }}</span> -->
                  </div>
                  <span class="page-range-info" [class.active-range-info]="currentPage === pageNum">
                    Range: {{ (pageNum - 1) * pageSize + 1 }}-{{ pageNum * pageSize > total_ss ? total_ss : pageNum
                    * pageSize }}
                  </span>
                </div>
              </mat-option>

              <!-- No Results Message -->
              <mat-option *ngIf="getFilteredPages().length === 0" disabled>
                <div class="no-pages-found">
                  <mat-icon>search_off</mat-icon>
                  <span>No pages found</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-card>

</div>

<app-loader *ngIf="loading"></app-loader>